import React from 'react';
import Grid from "@material-ui/core/Grid";
import {
  FormControl,
  Icon,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import {AppState} from "app/store";
import {useTranslation} from "react-i18next";
import {useStyles} from "../../../schedules/schedules.styles";
import {filterPayments} from "../../store/filter-payment.slice";
import {useRouteMatch} from "react-router-dom";
import {ROLES} from "../../../../constants/roles";
import useAuthority from "../../../../hooks/useAuthority";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

const AgentSearchPanel = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const {params}: any = useRouteMatch();
  const filters = useSelector((state: AppState) => state.agents.filterPayment);
  const {hasUserAnyAuthority} = useAuthority();
  const account = useSelector((state: AppState) => state.account.account);
 const formatDateToLocalISO = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

const getStartOfDay = (date: Date) => {
  const newDate = new Date(date);
  newDate.setHours(0, 0, 0, 0);
  return newDate;
};

const isDateBeforeFromDate = (date: Date | null) => {
  if (!date || !filters.fromDate) {
    return false;
  }

  return getStartOfDay(date) < getStartOfDay(new Date(filters.fromDate));
};
 const handleChange = (e: any) => {
  const { name, value } = e.target;

  let updatedFilters = {
    ...filters,
    [name]: value,
  };

  if (
    name === "fromDate" &&
    value &&
    updatedFilters.toDate &&
    new Date(updatedFilters.toDate) < new Date(value)
  ) {
    updatedFilters = {
      ...updatedFilters,
      toDate: "",
    };
  }

  if (
    name === "toDate" &&
    value &&
    updatedFilters.fromDate &&
    new Date(value) < new Date(updatedFilters.fromDate)
  ) {
    updatedFilters = {
      ...updatedFilters,
      toDate: "",
    };
  }

  const agentId = hasUserAnyAuthority([ROLES.ROLE_ADMIN])
    ? params.id
    : account.account!.id;

  dispatch(
    filterPayments(agentId, {
      ...updatedFilters,
      currencyId: params.currencyId,
    })
  );
  
};
  return (
      <Grid
          container
          direction="row"
          justify="flex-start"
          className={classes.root}
          style={{margin: '1rem 0', display: 'flex', alignItems: 'center'}}
          alignItems="flex-start"
      >
        <div style={{
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          paddingRight: '20px',
          paddingLeft: '20px'
        }}>
         <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <DatePicker
              label={t("app.main.schedules.searchPanel.datepicker.from", "From date")}
              name="fromDate"
              format="dd-MM-yyyy"
              value={filters.fromDate ? new Date(filters.fromDate) : null}
             onChange={(date: Date | null) =>
              handleChange({
                target: {
                  name: "fromDate",
                  value: date ? formatDateToLocalISO(date) : "",
                },
              })
            }
              inputVariant="outlined"
              size="small"
              autoOk
              disableToolbar
              variant="inline"
              maxDate={new Date("9999-12-12")}
              style={{ width: "100%" }}
              
            />
        </MuiPickersUtilsProvider>
          {filters.fromDate && (<>
            &nbsp;
            <IconButton style={{position: 'absolute', right: '1px'}} onClick={() => handleChange({
              target: {name: 'fromDate', value: ''}
            })} size='small'>
              <Icon fontSize='small'>close</Icon>
            </IconButton>
          </>)}
        </div>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          paddingRight: '20px'
        }}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
           <DatePicker
          label={t("app.main.schedules.searchPanel.datepicker.to", "To date")}
          name="toDate"
          format="dd-MM-yyyy"
          value={filters.toDate ? new Date(filters.toDate) : null}
          onChange={(date: Date | null) =>
            handleChange({
              target: {
                name: "toDate",
                value: date ? formatDateToLocalISO(date) : "",
              },
            })
          }
          inputVariant="outlined"
          size="small"
          autoOk
          disableToolbar
          variant="inline"
          minDate={filters.fromDate ? new Date(filters.fromDate) : undefined}
          shouldDisableDate={(date) => isDateBeforeFromDate(date)}
          minDateMessage={t(
            "app.main.schedules.searchPanel.datepicker.invalidToDate",
            "To date cannot be earlier than From date"
          )}
          maxDate={new Date("9999-12-12")}
          style={{ width: "100%" }}
        />
        </MuiPickersUtilsProvider>
          {filters.toDate && (<>
            &nbsp;
            <IconButton style={{position: 'absolute', right: '1px'}} onClick={() => handleChange({
              target: {name: 'toDate', value: ''}
            })} size='small'>
              <Icon fontSize='small'>close</Icon>
            </IconButton>
          </>)}
        </div>
        <div>
          <FormControl size='small' variant="outlined" style={{paddingRight: '20px'}}>
            <InputLabel id="demo-simple-select-outlined-label">{t( "app.main.schedules.searchPanel.input.status", "Status")}</InputLabel>
            <Select
                labelId="payment-status-select-label"
                value={filters.status || "ALL"}
                name="status"
                onChange={handleChange}
                label={t("app.main.schedules.searchPanel.input.status", "Status")}
              >
                <MenuItem value="ALL">
                  {t("app.main.schedules.searchPanel.menuItem1", "All")}
                </MenuItem>
                <MenuItem value="RESERVATION">Reservation</MenuItem>
                 <MenuItem value="CANCELLED">Cancelled</MenuItem>
                <MenuItem value="PAYMENT">Payment</MenuItem>
                <MenuItem value="PROVISION">Provision</MenuItem>
              </Select>
          </FormControl>
        </div>
      </Grid>
  );
};

export default AgentSearchPanel;
